import data from "../data/bodies.json";
import type { BodyId } from "./positions";

export interface BodyInfo {
  id: BodyId;
  nameZh: string;
  nameEn: string;
  kind: "star" | "planet" | "moon" | "dwarf" | "comet";
  radiusKm: number;
  parent?: BodyId;
  /** 数据是否已逐项核对来源；false 时不得用于 AI 事实表或界面“事实”文字。 */
  verified: boolean;
}

export const BODIES: readonly BodyInfo[] = data.bodies as BodyInfo[];
const byId = new Map(BODIES.map((b) => [b.id, b]));
export function bodyInfo(id: BodyId): BodyInfo {
  const b = byId.get(id);
  if (!b) throw new Error(`Unknown body: ${id}`);
  return b;
}
